import React from 'react';
import styled from 'styled-components';
import Tick from '../advance/Tick';

const CheckboxWrapper = styled.div`
  height: 1.4rem;
  width: 1.4rem;
  color: ${(props) => (props.checked ? 'var(--color-dirt_brown)' : 'var(--color-black)')};
  border: ${(props) => (props.checked ? 'none' : '1px solid var(--color-black)')};
  background-color: ${(props) =>
    props.checked ? 'var(--color-tan)' : '1px solid var(--color-white)'};
  border-radius: 2px;
  padding: 0.3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const Checkbox = ({ ...props }) => {
  return <CheckboxWrapper {...props}>{props.checked && <Tick color="#695934" />}</CheckboxWrapper>;
};

export default Checkbox;
